import { render } from "./MetadataManagement.vue?vue&type=template&id=a8da6cf2&scoped=true&ts=true"
import script from "./MetadataManagement.vue?vue&type=script&lang=ts"
export * from "./MetadataManagement.vue?vue&type=script&lang=ts"

import "./MetadataManagement.vue?vue&type=style&index=0&id=a8da6cf2&lang=scss&scoped=true"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8da6cf2"]])

export default __exports__